/**
 * Constants for the Community Questions feature
 */

// Validation constraints
export const QUESTION_MIN_LENGTH = 10
export const QUESTION_MAX_LENGTH = 1000
export const ANSWER_MIN_LENGTH = 10
export const ANSWER_MAX_LENGTH = 1000

// Validation error messages
export const ERROR_MESSAGES = {
  QUESTION_REQUIRED: 'Please enter your question',
  QUESTION_TOO_SHORT: `Question must be at least ${QUESTION_MIN_LENGTH} characters long`,
  QUESTION_TOO_LONG: `Question must not exceed ${QUESTION_MAX_LENGTH} characters`,
  ANSWER_REQUIRED: 'Please enter your answer',
  ANSWER_TOO_SHORT: `Answer must be at least ${ANSWER_MIN_LENGTH} characters long`,
  ANSWER_TOO_LONG: `Answer must not exceed ${ANSWER_MAX_LENGTH} characters`,
  PROFANITY_DETECTED: 'Your response contains inappropriate language. Please revise and try again.',
  SUBMISSION_FAILED: 'Failed to post. Please try again.',
} as const

// Special customer IDs
export const VANISHING_INC_CUSTOMER_ID = 33420

// Badge labels
export const BADGE_LABELS = {
  OFFICIAL: 'Vanishing Inc. Magic responds:',
  CREATOR: 'creator',
  COMMUNITY: 'Community member responds:',
} as const

// Query cache keys
export const CACHE_KEYS = {
  PRODUCT: 'Product',
  PRODUCT_QUESTIONS_INFINITE: 'ProductQuestions.infinite',
} as const
